export default __webpack_public_path__ + "static/media/Capgemini_Logo_Color_RGB.c82b3ba7.svg";